var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDesbloqueoDePuerta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#41af92;}.cls-3{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-desbloqueo-de-puerta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_20_copia",
    "data-name": "20 copia"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.77,112c0-7.45.22-14.71-.09-22-.17-4-4.18-7.17-8.29-7.35a8.76,8.76,0,0,0-9.18,6.92,44,44,0,0,0-.35,7c0,2.73,0,5.47,0,8.34h-7.93c0-5.47-.57-10.86.12-16.09a16.91,16.91,0,0,1,18-14.42,17.34,17.34,0,0,1,16.14,17.09c.13,5.85,0,11.7,0,17.55v3h4.65q11.79,0,23.58,0c4.44,0,6,1.58,6,6.08q0,11.28,0,22.57c0,4.11-1.68,5.82-5.74,5.82H131.3c-4.13,0-5.74-1.62-5.75-5.79q0-10.9,0-21.82c0-5.57,1.16-6.75,6.71-6.87C132.67,112.13,133.09,112.09,133.77,112Zm14.56,17.33h0c0,1.5-.32,3.1.11,4.46.32,1,1.58,2.41,2.46,2.44a3.48,3.48,0,0,0,2.59-2.25,43.53,43.53,0,0,0,0-9.2,3.47,3.47,0,0,0-2.56-2.27c-.87,0-2.17,1.36-2.49,2.37C148,126.28,148.33,127.88,148.33,129.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.85,172.8H150.7V157a2.4,2.4,0,0,0-4.79,0v15.74H135.82a2,2,0,0,0-.43,0V157a2.4,2.4,0,0,0-4.79,0v15.74H74.65V57.47l55.95-9.32V67a2.4,2.4,0,0,0,4.79,0V57.06a3,3,0,0,0,.43,0h10.09V67.23a2.4,2.4,0,1,0,4.79,0V54.7a2.39,2.39,0,0,0-2.4-2.39H135.82a2,2,0,0,0-.43,0v-7A2.39,2.39,0,0,0,132.6,43L71.86,53.08a2.39,2.39,0,0,0-2,2.36V172.8H55.22a2.4,2.4,0,1,0,0,4.79H164.85a2.4,2.4,0,0,0,0-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDesbloqueoDePuerta);
export default __webpack_public_path__ + "static/media/ic-desbloqueo-de-puerta.09c32f76decfe0bb798fb5cc93771df6.svg";
export { ForwardRef as ReactComponent };